<script setup lang="ts">
import TgIcon from 'assets/images/svg/tg.svg';
import VKIcon from 'assets/images/svg/vk.svg';
import MaxIcon from 'assets/images/svg/max.svg';

const subscribe = await queryContent('/subscribe').findOne();
</script>

<template>
  <section class="subscribe">
    <div class="container">
      <div class="subscribe__content">
        <div class="subscribe__content-inner">
          <h2 class="subscribe__title text-32">{{ subscribe.title }}</h2>
          <div class="subscribe__content-wrapper">
            <p class="subscribe__text text-20">
              {{ subscribe.subtitle }}
            </p>
            <div class="subscribe__buttons">
              <a :href="subscribe.telegram"
                 class="subscribe__button subscribe__button--telegram btn-success"
                 target="_blank"
              >
                Telegram
                <TgIcon />
              </a>
              <a :href="subscribe.vk"
                 class="subscribe__button subscribe__button--vk btn-primary"
                 target="_blank"
              >
                Вконтакте
                <VKIcon />
              </a>
              <a :href="subscribe.max"
                 class="subscribe__button subscribe__button--max btn-info"
                 target="_blank"
              >
                MAX
                <MaxIcon />
              </a>
            </div>
          </div>
        </div>
        <NuxtImg
          class="subscribe__bg"
          src="/img/subscribe/bg.png"
          alt="Фон"
          loading="lazy"
          format="webp"
        />
        <NuxtImg
          class="subscribe__bg-mobile"
          src="/img/subscribe/bg-mobile.png"
          alt="Фон"
          loading="lazy"
          format="webp"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.subscribe {
  padding-top: 55px;
  padding-bottom: 55px;
  background-color: var(--bg-grey);
  position: relative;

  @media (max-width: $mobile) {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  &__content {
    position: relative;
    border-radius: 30px;
    padding: 56px 0 54px 140px;
    max-width: 1563px;
    margin: auto;

    @media (max-width: $large) {
      padding: 30px 0 30px 52px;
    }

    @media (max-width: $medium) {
      padding: 16px 24px 24px 24px;
      border-radius: 20px;
    }

    @media (max-width: $mobile) {
      padding: 32px 24px;
    }

    &-inner {
      position: relative;
      z-index: 1;
    }
  }

  &__content-inner {
    display: flex;
    align-items: center;

    @media (max-width: $medium) {
      flex-direction: column;
      gap: 8px;
    }

    @media (max-width: $mobile) {
      flex-direction: column;
      gap: 20px;
    }
  }

  &__content-wrapper {
    @media (max-width: $mobile) {
      padding: 0 26px;
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 30px;

    @media (max-width: $mobile) {
      display: none;
    }

    &-mobile {
      display: none;

      @media (max-width: $mobile) {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 15px;
      }
    }

    @media (max-width: $medium) {
      border-radius: 20px;
    }
  }

  &__title {
    color: white;
    max-width: 272px;
    margin-right: 87px;
    margin-top: -20px;

    @media (max-width: $large) {
      margin-right: 40px;
    }

    @media (max-width: $medium) {
      margin-top: 0;
      margin-right: 0;
      max-width: 100%;
      font-size: 24px;
    }

    @media (max-width: $mobile) {
      text-align: center;
      font-size: 18px;
    }
  }

  &__text {
    color: white;
    margin-bottom: 30px;

    @media (max-width: $medium) {
      text-align: center;
      margin-bottom: 14px;
    }
  }

  &__buttons {
    position: relative;
    z-index: 2;
    display: flex;
    gap: 16px;

    @media (max-width: $mobile) {
      flex-direction: column;
      gap: 20px;
    }

    & .subscribe__button {
      display: flex;
      padding: 17px 42px;
      border-radius: 100px;
      font-weight: 500;
      font-size: 18px;
      line-height: 12px;
      gap: 10px;
      align-items: center;
      @include transition();

      @media (max-width: $medium) {
        padding: 14px 38px;
      }

      @media (max-width: $mobile) {
        justify-content: center;
      }
    }
  }

  &__icons {
    position: relative;
    display: flex;
    gap: 1rem;

    & .subscribe__icon {
      width: 4rem;
      height: 4rem;
      object-fit: contain;
    }

    & .subscribe__icon:nth-child(1) {
      transform: translate(-10%, -10%);
    }

    & .subscribe__icon:nth-child(2) {
      transform: translate(20%, 20%);
    }
  }
}
</style>
